import React from "react";

import "../../css/style.css";

const Loading = (props) => {
    const loadingText = props.resources?.Loading || "Loading...";

    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: props.bgColor,
            }}
        >
            <div
                className="spinner spinner-border"
                role="status"
                style={{
                    color: props.color,
                    width: "3rem",
                    height: "3rem",
                }}
            >
                <span className="visually-hidden">Loading...</span>
            </div>
            <span className="mt-2">{loadingText}</span>
        </div>
    );
};

export default Loading;